import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full py-12 px-4 border-t border-[#E8E6E3] bg-[#FAF9F7]" data-id="element-24">
      <div className="max-w-5xl mx-auto flex flex-row items-center justify-between text-sm text-[#9B9B9B]" data-id="element-25">
        <div className="flex items-center gap-8" data-id="element-26">
          {/* About Link */}
          <Link to="/about" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-27">
            About
          </Link>

          {/* Copyright */}
          <div className="font-medium" data-id="element-28">Andoe ©2026</div>
        </div>

        {/* Social Icons */}
        <div className="flex items-center gap-4" data-id="element-29">
          <a href="https://www.linkedin.com/company/andoe/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5C5C5C] transition-colors duration-200" aria-label="LinkedIn" data-id="element-30">
            <Linkedin className="h-4 w-4" data-id="element-31" />
          </a>
          <a href="https://www.instagram.com/andoe.work/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5C5C5C] transition-colors duration-200" aria-label="Instagram" data-id="element-32">
            <Instagram className="h-4 w-4" data-id="element-33" />
          </a>
        </div>
      </div>
    </footer>;
}